
import { FC } from "react";
import { AuthenticatedLayout } from "../../layouts";
import { TaxProfileList } from "../../components/TaxProfile";

export interface ITaxProfileListPage {}

export const TaxProfileListPage: FC<ITaxProfileListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Tax Profile List"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'Tax Profile', navigateTo: '/tax-profile/list'}]}
      mainContents={<TaxProfileList />}
    />
  );
};
